module.exports = __webpack_public_path__ + "static/cases-tile-2-1-08cc59a541681804b02d99de252ef2c1.png";